import { type NotificationModel, type NotificationResponse } from '@/models/notification.model';
import { ValidatorResult } from '@/models/validation-result.model';
import { CrudService } from './crud.service';

export class NotificationService {
  private crudService: CrudService<NotificationModel>;

  constructor() {
    this.crudService = new CrudService<NotificationModel>('notifications');
  }

  public async getNotifications(
    accountId: string,
    page: number,
    take: number,
  ): Promise<ValidatorResult<NotificationResponse>> {
    const queryParams = new URLSearchParams({
      accountId,
      page: `${page}`,
      take: `${take}`,
    });

    return await this.crudService.do('get', `?${queryParams}`);
  }

  public async markNotificationsAsRead(accountId: string, notificationIds: string[]): Promise<void> {
    const queryParams = new URLSearchParams({ accountId });
    await this.crudService.do('patch', `?${queryParams}`, { ids: notificationIds });
  }
}
